module.exports = __webpack_public_path__ + "img/circle-microphone.297a870f.svg";